import { Injectable } from '@angular/core';

import { WarnParameter } from '../components/user-admin-warning-tab/enums/warn-parameter.enum';
import { WarnThresold } from '../components/user-admin-warning-tab/user-admin-warning-tab.component';

@Injectable({
  providedIn: 'root',
})
export class UserAdminWarningConfigService {
  readonly levels = [0, 1, 2, 3, 4] as const;

  readonly levelIcons: Record<number, unknown> = {
    0: ['fal', 'bell-slash'],
    1: ['fal', 'square-1'],
    2: ['fal', 'square-2'],
    3: ['fal', 'square-3'],
    4: ['fal', 'square-4'],
  };

  readonly order: Record<string, number> = {
    [WarnParameter.windWarning]: 1,
    [WarnParameter.nowcast]: 2,
    [WarnParameter.heavyRainWarning]: 3,
    [WarnParameter.precipitationWarning]: 4,
  };

  readonly configurableParameters = [
    'info',
    WarnParameter.nowcast,
    WarnParameter.windWarning,
    WarnParameter.precipitationWarning,
    WarnParameter.heavyRainWarning,
  ] as const;

  createStandardThresholds(): WarnThresold[] {
    return [
      {
        parameter: WarnParameter.heavyRainWarning,
        level: 1,
      },
      {
        parameter: WarnParameter.precipitationWarning,
        level: 1,
      },
      {
        parameter: WarnParameter.windWarning,
        level: 1,
      },
      {
        parameter: WarnParameter.nowcast,
        level: 1,
      },
    ];
  }

  getAllowedParameters(
    warnProducts: any[] = [],
    isProductActive: (productId: any) => boolean
  ): string[] {
    const allowedParameters = new Set<string>();

    for (const product of warnProducts) {
      if (!isProductActive(product.id)) {
        continue;
      }

      for (const parameter of this.configurableParameters) {
        if (product[parameter]) {
          allowedParameters.add(parameter);
        }
      }
    }

    return Array.from(allowedParameters);
  }
}
